import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Input } from "./Input";
export function DurationInput({ minutes, unit, onChange, label, disabled, allowClear = false, className, }) {
    const [editing, setEditing] = useState(false);
    const [text, setText] = useState("");
    const requestedMinutes = useRef(null);
    const quantity = unit === "Minute" ? minutes : minutes / 60;
    const display = !Number.isFinite(quantity) || (allowClear && quantity === 0)
        ? ""
        : String(Number(quantity.toFixed(12)));
    useEffect(() => {
        setEditing(false);
    }, [unit]);
    useEffect(() => {
        if (minutes !== requestedMinutes.current)
            setText(display);
    }, [minutes, display]);
    return (_jsx(Input, { label: label, "aria-label": label ?? (unit === "Minute" ? "Minutes" : "Hours"), type: "number", step: unit === "Minute" ? 1 : 0.25, min: allowClear ? 0 : unit === "Minute" ? 15 : 1, value: editing ? text : display, onFocus: () => { setText(display); setEditing(true); }, onChange: (e) => {
            setText(e.target.value);
            const value = e.target.value === "" && !allowClear ? NaN : Number(e.target.value);
            const nextMinutes = unit === "Minute" ? value : value * 60;
            requestedMinutes.current = nextMinutes;
            onChange(nextMinutes);
        }, onBlur: () => setEditing(false), placeholder: allowClear ? "-" : undefined, disabled: disabled, className: className }));
}
